import React from 'react'
import { useSelector } from 'react-redux'
import Slider from 'react-slick'
import Image from 'next/image' // Import Next.js Image
import { FaChevronCircleLeft, FaChevronCircleRight } from 'react-icons/fa'

const SliderViewDesktop = ({ handleSelectedOptionChange, selectedParameters, categoryKey }) => {
  const { textToImagePrompts } = useSelector((state) => state.prompt)

  const ArrowLeft = ({ onClick }) => (
    <button aria-label="left" className="mb-6 flex items-center absolute top-1/4 left-[-40px] z-40" onClick={onClick}>
      <FaChevronCircleLeft />
    </button>
  )

  const ArrowRight = ({ onClick }) => (
    <button aria-label="right" className="mb-6 flex items-center absolute top-1/4 right-[-40px] z-40" onClick={onClick}>
      <FaChevronCircleRight />
    </button>
  )

  const setting2 = {
    button: true,
    swipeToSlide: true,
    slidesToShow: 6,
    slidesToScroll: 2,
    infinite: false,
    prevArrow: <ArrowLeft />,
    nextArrow: <ArrowRight />,
    responsive: [
      {
        breakpoint: 1024, // Desktop
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768, // Tablet
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <Slider {...setting2}>
      {textToImagePrompts[categoryKey]?.map((item, i) => (
        <div
          className="overflow-hidden flex-none w-12 md:w-[100px]"
          onClick={() => handleSelectedOptionChange(categoryKey, item)}
          key={i}
        >
          <div className="relative h-12 w-12 md:h-[100px] md:w-[100px]">
            <Image
              src={item.prompt_imageURL || '/assets/editor-modal/image1.png'}
              alt={item?.title || 'Image'}
              fill // Fills the parent div
              className={`rounded-md object-cover ${
                selectedParameters[categoryKey]?.title === item?.title ? 'border-2 border-solid border-blue-500' : ''
              }`}
              placeholder="blur" // Enables blur placeholder
              blurDataURL={item.prompt_imageURL || '/assets/editor-modal/image1.png'}
              sizes="(max-width: 768px) 48px, 100px"
            />
          </div>
          <p className="break-words mt-2 text-[10px] leading-none text-center font-medium capitalize">{item?.title}</p>
        </div>
      ))}
    </Slider>
  )
}

export default SliderViewDesktop
